import React from "react";
import { signInWithGoogle } from "../../../../server/helpers/auth";
import { GoogleIcon } from "../../Icons/Icon";
import { checkAuthStatus } from "../../../../server/helpers/firebase";
import { useSelector, useDispatch } from "react-redux";
import { LoginUserHardPayWallEvent, AnonymousUserHardPayWallEvent } from "../../../utils/gtm";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { cdpEventHandler } from "../../../../api/utils";
const GooglePaywall = ({ numberRemaining, isLoggedIn, storyDetail, isLoginRequired = false }) => {
  const dispatch = useDispatch();
  checkAuthStatus(dispatch);

  const getEmail = () => {
    if (typeof window !== "undefined" && window.localStorage) {
      const storedUser = sessionStorage.getItem("SUBSCRIBED_USER");
      return storedUser ? JSON.parse(storedUser) : null;
    }
    return null;
  };

  const getUserProfileId = () => {
    if (typeof window !== "undefined" && window.sessionStorage) {
      const storedProfileId = sessionStorage.getItem("USER_PROFILE_ID");
      return storedProfileId ? JSON.parse(storedProfileId) : null;
    }
    return null;
  };

  const user = useSelector((state) => get(state, ["firebaseUser"], null));

  const profileId = useSelector((state) => get(state, ["userProfileID"], null)) || getUserProfileId();
  const isSubscribed = useSelector((state) => get(state, ["isSubscribedUser"], null)) || getEmail();

  const loginUserNonSub = () => {
    let data = {
      email: user.email,
      event_type: "paywall_shown",
      event_time: new Date().toISOString(),
      source: "website",
      story_id: storyDetail["story-content-id"],
      story_headline: storyDetail.headline,
      story_author: storyDetail["author-name"],
      story_sections: storyDetail.sections.map((section) => section.name),
      is_subscribed: isSubscribed,
      profile_id: profileId,
    };
    cdpEventHandler(data);
  };

  async function googleSignIn() {
    await signInWithGoogle()
      .then(async (result) => {
        setCookies(result.user.email);
        window.location.reload();
      })
      .catch((err) => {});
  }
  const Paywall = ({ numberRemaining }) => {
    return (
      <div className="my-8 flex flex-col items-center justify-center gap-4 bg-white px-4 py-8 shadow-sm">
        <h2 className="soft-paywall text-center font-inter text-[20px] font-[600] capitalize text-primary">
          Please Sign In To Continue Reading
        </h2>

        <p className="text-center font-inter text-[18px] font-[400] text-gray-500">
          {numberRemaining > 1 ? (
            <span>
              You have {numberRemaining} remaining free article this week. Please Sign In to read the full article.
            </span>
          ) : (
            <span>This is your last free article this week. Please Sign In to read the full article.</span>
          )}
        </p>

        <div className={`mt-3 flex items-center justify-center gap-6`}>
          <div
            className={`flex cursor-pointer items-center gap-3 rounded border border-gray-300 bg-transparent px-5 py-1.5`}
          >
            <Link href={`/signin`}>
              <button className="min-h-[24px] text-sm font-medium text-gray-500 hover:text-primary">Sign In</button>
            </Link>
          </div>
          <button
            className={`flex cursor-pointer items-center gap-3 rounded border border-gray-300 bg-transparent px-5 py-1.5`}
            onClick={googleSignIn}
          >
            <GoogleIcon />
            <span className="text-sm font-medium text-gray-500">Sign In with Google</span>
          </button>
        </div>
      </div>
    );
  };

  const LoginRequiredPaywall = () => {
    return (
      <div className="my-8 flex flex-col items-center justify-center gap-4 bg-white px-4 py-8 shadow-sm">
        <h2 className="text-center font-inter text-[20px] font-[600] capitalize text-primary">Don't Stop Midway!</h2>

        <p className="text-center font-inter text-[18px] font-[400] text-gray-500">
          Sign-in to get unlimited access to thousands of Swarajya stories.
        </p>

        <div className={`mt-3 flex items-center justify-center gap-6`}>
          <div
            className={`flex cursor-pointer items-center gap-3 rounded border border-gray-300 bg-transparent px-5 py-1.5`}
          >
            <Link href={`/signin`}>
              <button className="min-h-[24px] text-sm font-medium text-gray-500 hover:text-primary">Sign In</button>
            </Link>
          </div>
          <button
            className={`flex cursor-pointer items-center gap-3 rounded border border-gray-300 bg-transparent px-5 py-1.5`}
            onClick={googleSignIn}
          >
            <GoogleIcon />
            <span className="text-sm font-medium text-gray-500">Sign In with Google</span>
          </button>
        </div>
      </div>
    );
  };

  const HardPaywall = () => {
    user ? LoginUserHardPayWallEvent() : AnonymousUserHardPayWallEvent();
    user && loginUserNonSub();
    return (
      <div className="my-8 flex flex-col items-center justify-center gap-4 bg-white px-4 py-8 shadow-sm">
        <h2 className="text-center font-satoshi text-[20px] font-[600] capitalize text-primary">
          Thank you for reading but do please subscribe!
        </h2>

        <p className="text-center font-satoshi text-[18px] font-[400] text-gray-500">
          Unfortunately you&apos;ve run out of your quota of free articles. Please do sign in below or buy a
          subscription to continue reading.
        </p>

        <Link
          href={
            "https://join.swarajyamag.com/print/?utm_source=midarticle&utm_medium=site&utm_campaign=continuereading"
          }
          target="_blank"
        >
          <button
            type="submit"
            className="rounded-sm border border-transparent bg-primary px-6 py-2 font-satoshi text-sm text-white transition-all focus:outline-none focus:ring-offset-2 dark:focus:ring-offset-gray-800"
            aria-label="subscribe_btn"
          >
            Subscribe
          </button>
        </Link>

        {!user && (
          <p className="text-center font-satoshi text-sm font-[400] text-gray-500">
            Already a subscribed user ?{" "}
            <Link href={`/signin`} className="text-primary">
              Sign In
            </Link>
          </p>
        )}

        {/* <div className={`mt-3 flex items-center justify-center gap-6`}>
          <Link href="/signin">
            <div
              className={`flex cursor-pointer items-center gap-3 rounded border border-gray-300 bg-transparent px-5 py-1.5 text-gray-700 hover:text-primary `}
            >
              <button className="h-[24px] text-sm font-medium ">Sign in</button>
            </div>
          </Link>
          <div
            className={`flex cursor-pointer items-center gap-3 rounded border border-gray-300 bg-transparent px-5 py-1.5`}
            onClick={googleSignIn}
          >
            <GoogleIcon />
            <span className="text-sm font-medium text-gray-700">
              Sign in with Google
            </span>
          </div>
        </div> */}
      </div>
    );
  };

  return (
    <>
      {isLoginRequired ? (
        <LoginRequiredPaywall />
      ) : numberRemaining === 0 ? (
        <HardPaywall isLoggedIn={isLoggedIn}></HardPaywall>
      ) : (
        <Paywall numberRemaining={numberRemaining} />
      )}
    </>
  );
};

export default GooglePaywall;
